import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04e75c12"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slide-pagination"
}, null, -1));
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 0,
  class: "footer-box"
};
const _hoisted_9 = {
  class: "icon-box"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-pause"
}, null, -1));
const _hoisted_11 = {
  class: "time-bar"
};
const _hoisted_12 = {
  class: "time-box"
};
const _hoisted_13 = {
  class: "time-pro"
};
const _hoisted_14 = {
  class: "time-end"
};
const _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "guideDetail",
    style: _normalizeStyle({
      '--guideThemeColor': $options.guideThemeColor
    })
  }, [_createElementVNode("div", _hoisted_1, _toDisplayString($data.detail.explainObj), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.image, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
      class: "imgs",
      src: item
    }, null, 8, _hoisted_5)]);
  }), 256))]), _hoisted_6], 512), _createElementVNode("div", {
    innerHTML: $data.detail.introduction,
    class: "introduction",
    onClick: _cache[0] || (_cache[0] = $event => $options.wrapClick($event, $data.detail.introduction))
  }, null, 8, _hoisted_7), $data.detail.audioUrl ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "icon-play-left",
    onClick: _cache[1] || (_cache[1] = $event => $options.barBack())
  }), _createElementVNode("div", {
    class: _normalizeClass(`icon-play ${!$data.isPlay ? '' : 'closeIcon'}`),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.playAudio && $options.playAudio(...args))
  }, null, 2), _hoisted_10, _createElementVNode("div", {
    class: "icon-play-right",
    onClick: _cache[3] || (_cache[3] = $event => $options.barPor())
  })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    style: _normalizeStyle(`width: ${$data.sWidth}%`)
  }, null, 4)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($data.currentTime), 1), _createElementVNode("span", _hoisted_14, _toDisplayString($data.totalTime), 1)])])) : _createCommentVNode("", true), $data.detail.audioUrl ? (_openBlock(), _createElementBlock("audio", {
    key: 1,
    loop: "loop",
    volume: "1",
    onTimeupdate: _cache[4] || (_cache[4] = (...args) => $options.onTimeupdate && $options.onTimeupdate(...args)),
    ref: "audioItem",
    onCanplay: _cache[5] || (_cache[5] = $event => $options.getDuration('audioItem'))
  }, [_createElementVNode("source", {
    src: $data.detail.audioUrl,
    type: "audio/mpeg"
  }, null, 8, _hoisted_15)], 544)) : _createCommentVNode("", true)], 4);
}